import ReportsDoughnutChart from "../Charts/ReportsDoughnutChart.vue";
import ThinBarChart from "../Charts/ThinBarChart.vue";
import SupportTracker from '../Charts/SupportTracker.vue';
import HelperMixin from '../../Shared/HelperMixin.vue'
export default {
    name: 'home',
    mixins: [HelperMixin],
    components: {
        ReportsDoughnutChart,
        ThinBarChart,
        SupportTracker,
    },

    async created() {

        this.loginDetails = await this.CheckLoginStatus();

        if (this.loginDetails) {
            if (this.loginDetails.userType != 1
                && this.loginDetails.userType != 2
                && this.loginDetails.userType != 3)
                this.logout();
        } else {
            this.logout();
        }

            
        window.scrollTo(0, 0);
        this.GetInfo();
    },
    data() {
        return {

            Info: [],
        };
    },
    methods: {

        GetInfo() {
            this.$blockUI.Start();
            this.$http.GetDashboardInfo()
                .then(response => {
                    this.$blockUI.Stop();
                    this.Info = response.data.info;
                })
                .catch(() => {
                    this.$blockUI.Stop();
                });
        },

    }    
}
